<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <button @click="addNewType"
                        class="btn btn-primary my-2 my-sm-0"
                        type="button">
                    <icon name="plus"></icon>
                    เพิ่มหมวดหมู่ใหม่
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th>ลำดับ</th>
                    <th>ชื่อหมวดหมู่</th>
                    <th>จัดการ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,i) in ProductSpecial">
                    <td>{{ i + 1 }}</td>
                    <td>{{ x.name }}</td>
                    <td>
                        <a @click="showByID(x.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="showDeleteModal(x.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="ProductSpecial.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getPaginate">
                </vue-pagination>
            </div>
        </div>
        <b-modal hide-footer hide-header ref="delete_item">
            <delete-confirm-modal @submit="deleteItem">
            </delete-confirm-modal>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import FormTextarea from "bootstrap-vue/src/components/form-textarea/form-textarea";
import ImportData from "../Import/ImportData";
import ExportData from "../Export/ExportData";
import VuePagination from "../../Pagination";
import AddPriceProductModal from "../../Order/Overview/AddPriceProductModal";
import Loading from "../../Utility/Loading";
import DatePicker from "vue2-datepicker";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";

export default {
    name: "products-type",
    components: {
        Loading,
        VuePagination,
        ExportData,
        ImportData,
        FormTextarea,
        Multiselect,
        AddPriceProductModal,
        DatePicker,
        DeleteConfirmModal
    },
    data() {
        return {
            delete_id: ''
        };
    },
    created() {
        this.getPage(1);
    },
    computed: {
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            ProductSpecial: state => {
                return state.Products.special;
            },
            dataPaginate: state => {
                return state.Products.specialPaginate
            },
        })
    },
    methods: {
        addNewType() {
            this.$router.push('products_type_info/create')
        },
        getPage(page) {
            //console.log(page)
            this.$store.dispatch('Products/getSpecial', page)
        },
        getPaginate() {
            this.getPage(this.dataPaginate.current_page)
        },
        showByID(id) {
            this.$router.push(`products_type_info/${id}`)
        },
        showDeleteModal(id) {
            this.delete_id = id
            this.$refs.delete_item.show()
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide()
        },
        deleteItem(submit) {
            //console.log(submit)
            if (submit)
                this.$store.dispatch('Products/deleteSpecial', this.delete_id).then(() => {
                    this.getPage(1);
                    this.hideDeleteModal();
                })
            else
                this.hideDeleteModal();
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
